<div
  class="custom-quick-cart-link"
  [class.custom-mini-cart-active]="!isCollapsed"
  ishClickOutside
  (isClickedOutside)="collapse(); allowScroll()"
>
  <a
    #prsMiniCartTrigger
    href="javascript:;"
    role="button"
    data-testing-id="prs-mini-cart-trigger"
    [attr.aria-expanded]="!isCollapsed"
    [attr.aria-controls]="'prs-mini-cart-panel'"
    [attr.aria-label]="
      'shopping_cart.ministatus.label' | translate: { '0': (itemCount$ | async) || 0 }
    "
    (click)="toggleCollapse(); $event.preventDefault()"
    (keydown.enter)="toggleCollapse(); $event.preventDefault()"
    (keydown.space)="toggleCollapse(); $event.preventDefault()"
  >
    <span class="prs-mini-cart-trigger">
      <span class="prs-mini-cart-icon" aria-hidden="true">
        <i class="icon-shopping-bag"></i>
        <span class="custom-mini-cart-link-item-count">{{ itemCount$ | async }}</span>
      </span>
      <span class="prs-mini-cart-label">{{ 'shell.portal.cart' | translate }}</span>
    </span>
  </a>

  <div
    #prsMiniCartPanel
    class="custom-mini-cart"
    id="prs-mini-cart-panel"
    role="dialog"
    tabindex="-1"
    [attr.aria-modal]="!isCollapsed ? true : null"
    [attr.aria-label]="'shopping_cart.ministatus.panel.label' | translate"
    [attr.aria-hidden]="isCollapsed ? true : null"
    [attr.inert]="isCollapsed ? '' : null"
  >
    <button
      #prsMiniCartClose
      type="button"
      class="close custom-mini-cart-close"
      data-testing-id="prs-mini-cart-close"
      [title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="collapse(); allowScroll()"
    >
      <span aria-hidden="true"><i class="icon-x"></i> {{ 'dialog.close.text' | translate }}</span>
    </button>
    <custom-lazy-mini-basket-content />
  </div>
</div>

<!-- Keep mounted so backdrop can fade with the panel (same pattern as All drawer) -->
<div
  class="custom-mini-cart-white-drop"
  [class.is-open]="!isCollapsed"
  [attr.aria-hidden]="isCollapsed ? 'true' : null"
  (click)="collapse(); allowScroll()"
></div>

<!-- dummy element tracking basket loading for cypress tests -->
@if (basketLoading$ | async) {
<span class="loading" style="display: none"></span>
}
